import axios from 'axios'
import _ from 'lodash'

import * as types from '../mutation-types'
import * as api from '@/api/url'
import {
    getInfo,
    parseDateFormat,
    getTemp,
    restoreDate,
    setCreativeNm
} from '@/assets/func'

const state = {
  campaignInfo: {}, // --> 선택된 켐페인 정보
  currentCampaign: {},
  campaignDetailTap: 'overview', // --> campign 상세 -> 내부 탭 use
  currentAdKnd: '',
  contractData: {
    contract: [],
    contractAndDate: []
  }, // --> 상품별
  sizeData: {
    size: [],
    sizeAndDate: []
  }, // --> 사이즈별
  creativeData: {
    creative: [],
    creativeAndDate: []
  }, // --> 소재별
  cgData: {
    creativeGroup: [],
    creativeGroupAndDate: []
  },
  geoData: {
    geo: [],
    geoAndDate: []
  }, // --> 지역별
  isGeo: false
}

const getters = {
  camDetailTap: (state) => {
    return state.campaignDetailTap
  },
  getData: (state) => {
    return tab => {
      switch (tab) {
        case 'creative':
          return state.creativeData.creativeAndDate
        case 'creativeGroup':
          return state.cgData.creativeGroupAndDate
        case 'size':
          return state.sizeData.sizeAndDate
        case 'contract':
          return state.contractData.contractAndDate
        case 'geo':
          return state.geoData.geoAndDate
      }
    }
  },
  getInfoLength: (state) => {
    return tab => {
      let res
      switch (tab) {
        case 'creative':
          res = state.creativeData.creative.length
          break
        case 'creativeGroup':
          res = state.cgData.creativeGroup.length
          break
        case 'size':
          res = state.sizeData.size.length
          break
        case 'contract':
          res = state.contractData.contract.length
          break
        case 'geo':
          res = state.geoData.geo.length
          break
      }
      return res
    }
  },
  getTitleInfo: (state) => {
    return tab => {
      let res = []
      switch (tab) {
        case 'creative':
          state.creativeData.creative.forEach(function (data) {
            res.push(setCreativeNm(data))
          })
          return res
          // return _.map(state.creativeData.creative, 'creative_nm')
        case 'creativeGroup':
          state.cgData.creativeGroup.forEach(function (data) {
            const krNm = data.creative_kr_nm ? data.creative_kr_nm : data.group_nm
            res.push(krNm + ' (' + data.ad_knd_nm + ')')
          })
          return res
        case 'size':
          state.sizeData.size.forEach(function (data) {
            res.push(data.size_nm + ' ' + data.ad_knd_nm)
          })
          return res
        case 'geo':
          state.geoData.geo.forEach(function (data) {
            res.push(data.geo_nm + ' ' + data.ad_knd_nm)
          })
          return res
        default :
          return _.map(state.contractData.contract, function (o) {
            return o.ad_knd_nm + ' (' + o.dp_knd_nm + ')'
          })
      }
    }
  },
  daysImpData: (state, getters) => {
    return (tab, isExcel) => {
      let data = getters.getData(tab)
      let res = []
      let list = []
      let sDataForm = getTemp(tab)
      if (data === undefined || data.length === 0) {
        let obj = {
          ymd: '',
          data: [],
          imp: 0,
          click: 0,
          ctr: 0,
          vtr: 0,
          budgetAmt: 0
        }
        res.push(obj)
        return res
      }

      if ((tab === 'size' || tab === 'geo') && isExcel === false) {
        data = data.filter(function (a) {
          return (a.ad_knd_nm === state.currentAdKnd) || (a.ad_knd_nm === null)
        })
        let flag = false
        let t = data.filter(function (a, i) {
          if (i === 0 && a.ad_knd_nm === null) flag = true
          if (a.ad_knd_nm !== null) flag = false
          if (flag) return false
          return true
        })
        list = _.values(_.groupBy(t, 'ymd'))
      } else {
        list = _.values(_.groupBy(data, 'ymd'))
      }
      list.forEach(function (data, i) {
        let imp = _.sumBy(data, function (o) { return o.imp_cnt * 1 })
        let budgetAmt = _.sumBy(data, function (o) { return o.budget_amt * 1 })
        let click = _.sumBy(data, function (o) { return o.click_cnt * 1 })
        let view = _.sumBy(data, function (o) { return o.view_cnt * 1 })
        let obj = {
          ymd: data[0].ymd,
          data: data,
          imp: imp,
          click: click,
          budget_amt: budgetAmt,
          view: view,
          ctr: 0,
          vtr: 0
        }
        if (imp !== 0 && click !== 0) {
          obj.ctr = click / imp * 100
        }
        if (imp !== 0 && view !== 0) {
          obj.vtr = view / imp * 100
        }
        obj.ctr = isNaN(obj.ctr) ? 0 : obj.ctr
        obj.vtr = isNaN(obj.vtr) ? 0 : obj.vtr

        let date = parseDateFormat(obj.ymd)
        date = new Date(date)
        if (state.tab === 'size' && list[i - 1]) {
          let fdate = new Date(parseDateFormat(list[i - 1][0].ymd))
          let interval = 86400000
          let term = date - fdate
          if (term !== interval) {
            for (let i = 1; i < term / interval; i++) {
              fdate.setDate(fdate.getDate() + 1)
              sDataForm.ymd = restoreDate(fdate)
              let temp = {
                ymd: sDataForm.ymd,
                data: [sDataForm],
                imp: 0,
                click: 0,
                ctr: 0,
                budget_amt: 0
              }
              res.push(temp)
            }
          }
        }

        res.push(obj)
      })
      return res // 사이즈별 리포트.
    }
  },
  daysImpTotal: (state, getters) => {
    return tab => {
      let data = getters.getData(tab)
      if (tab !== 'size' && tab !== 'geo') {
        let imp = _.sumBy(data, function (o) { return o.imp_cnt * 1 })
        let budgetAmt = _.sumBy(data, function (o) { return o.budget_amt * 1 })
        let click = _.sumBy(data, function (o) { return o.click_cnt * 1 })
        let ctr = (click / imp * 100).toFixed(2)
        ctr = isNaN(ctr) ? 0 : ctr
        return tab === 'contract' || tab === 'creativeGroup' ? [imp, click, ctr, budgetAmt] : [imp, click, ctr]
      } else {
        let list = _.groupBy(data, 'ad_knd_nm')
        let keys = Object.keys(list)
        let res = {}
        for (let i = 0; i < keys.length; i++) {
          if (keys[i] === 'null') continue
          let arr = list[keys[i]]
          let imp = _.sumBy(arr, function (o) { return o.imp_cnt * 1 })
          let click = _.sumBy(arr, function (o) { return o.click_cnt * 1 })
          let ctr = (click / imp * 100).toFixed(2)
          res[keys[i]] = [imp, click, ctr]
        }
        return res
      }
    }
  },
  contentImpData: (state, getters) => {
    return tab => {
      let data = getters.getData(tab)
      let sDataForm = getTemp(tab)
      let res = []

      if (data === undefined || data.length === 0) {
        let obj = {
          name: '',
          data: [],
          imp: 0,
          click: 0,
          ctr: 0
        }

        res.push(obj)
        return res
      }

      let names = getters.getTitleInfo(tab)
      let length = getters.getInfoLength(tab)
      let list = []
      let checkArr = []
      let keyword
      switch (tab) {
        case 'creative':
          keyword = 'creative_nm'
          break
        case 'creativeGroup':
          keyword = 'group_nm'
          break
        case 'size':
          keyword = 'size_nm'
          break
        case 'geo':
          keyword = 'geo_nm'
          break
        default :
          keyword = 'ad_knd_nm'
          break
      }

      switch (tab) {
        case 'size':
          data = _.values(_.groupBy(data, function (o) {
            return o.size_nm + o.ad_knd_nm
          }))
          break
        case 'geo':
          data = _.values(_.groupBy(data, function (o) {
            return o.geo_nm + o.ad_knd_nm
          }))
          break
        default:
          data = _.values(_.groupBy(data, 'ymd'))
      }

      for (let i = 0; i < length; i++) {
        list[i] = []
      }
      data.forEach(function (c, k) {
        if (c[0][keyword] !== null) {
          for (let i = 0; i < c.length; i++) {
            let index
            switch (tab) {
              case 'contract':
                index = names.indexOf(c[i][keyword] + ' (' + c[i].dp_knd_nm + ')')
                break
              case 'size':
                index = names.indexOf(c[i][keyword] + ' ' + c[i].ad_knd_nm)
                break
              case 'creative' :
                // const dataSplit = c[i][keyword].split('/')
                // const creativeKr = c[i]['creative_kr_nm'] ? c[i]['creative_kr_nm'] + ' (' + dataSplit[dataSplit.length - 1] + ')asdfsf' : c[i][keyword]
                const creativeKr = setCreativeNm(c[i])
                if (creativeKr !== undefined) index = names.indexOf(creativeKr)
                break
              case 'creativeGroup':
                const krNm = c[i]['creative_kr_nm'] ? c[i]['creative_kr_nm'] + ' (' + c[i].ad_knd_nm + ')' : c[i][keyword] + ' (' + c[i].ad_knd_nm + ')'
                index = names.indexOf(krNm)
                break
              case 'geo':
                index = names.indexOf(c[i][keyword] + ' ' + c[i].ad_knd_nm)
                break
            }
            let temp = list[index]
            if (temp[temp.length - 1]) {
              let date = parseDateFormat(c[i].ymd)
              date = new Date(date)
              let fdate = new Date(parseDateFormat(temp[temp.length - 1].ymd))
              let interval = 86400000
              let term = date - fdate

              if (term !== interval) {
                for (let i = 1; i < term / interval; i++) {
                  fdate.setDate(fdate.getDate() + 1)
                  sDataForm.ymd = restoreDate(fdate)
                  list[index].push(_.clone(sDataForm))
                }
              }
            }

            list[index].push(c[i])
            checkArr[index] = true
          }
        }
      })

      list.forEach(function (data, i) {
        let imp = _.sumBy(data, function (o) { return o.imp_cnt * 1 })
        let click = _.sumBy(data, function (o) { return o.click_cnt * 1 })
        let budgetAmt = _.sumBy(data, function (o) { return o.budget_amt * 1 })
        let obj = {
          name: names[i],
          data: data,
          imp: imp,
          click: click,
          ctr: 0,
          budget_amt: budgetAmt
        }
        if (imp !== 0 && click !== 0) {
          obj.ctr = click / imp * 100
        }
        obj.ctr = isNaN(obj.ctr) ? 0 : obj.ctr
        res.push(obj)
      })
      return res
    }
  },
  getInterCreative: (state, getters) => {
    let arr = state.creativeData.creativeAndDate
    return (crNm) => {
      if (crNm !== 'total') {
        let list = _.groupBy(arr, 'creative_nm')
        return list[crNm]
      } else {
        let totalData = getters.getInterPlayDaysDataForCreative
        let list = _.groupBy(arr, 'ymd')
        totalData.forEach(function (data) {
          data.list = list[data.ymd]
        })
        return totalData
      }
    }
  },
  getInterCreativeGroup: (state, getters) => {
    let arr = state.cgData.creativeGroupAndDate
    return (crNm) => {
      if (crNm !== 'total') {
        let list = _.groupBy(arr, 'creative_nm')
        return list[crNm]
      } else {
        let totalData = getters.getInterPlayDaysDataForCreative
        let list = _.groupBy(arr, 'ymd')
        totalData.forEach(function (data) {
          data.list = list[data.ymd]
        })
        return totalData
      }
    }
  },
  getInterPlayDaysDataForCreative: (state) => {
    let temp = state.contractData.contractAndDate
    let res = []
    temp = _.groupBy(temp, 'ymd')
    Object.keys(temp).forEach((key) => {
      let obj = {
        ymd: temp[key][0].ymd,
        imp_cnt: _.sumBy(temp[key], function (o) { return o.imp_cnt * 1 }),
        click_cnt: _.sumBy(temp[key], function (o) { return o.click_cnt * 1 }),
        ctr: 0,
        view_cnt: _.sumBy(temp[key], function (o) { return o.view_cnt * 1 }),
        cpcv: _.sumBy(temp[key], function (o) { return o.cpcv * 1 }),
        cpvc: _.sumBy(temp[key], function (o) { return o.cpvc * 1 }),
        vtr: 0,
        play_sec_avg: '',
        end_rate: '',
        play_Q1_rate: '',
        play_Q2_rate: '',
        play_Q3_rate: ''
      }

      if (obj.imp_cnt !== 0 && obj.click_cnt !== 0) {
        obj.ctr = obj.click_cnt / obj.imp_cnt * 100
      }
      obj.ctr = isNaN(obj.ctr) ? 0 : obj.ctr
      if (!obj.cpcv && obj.imp_cnt !== 0 && obj.view_cnt !== 0) {
        obj.vtr = obj.view_cnt / obj.imp_cnt * 100
      }
      if (obj.cpcv) obj.vtr = 100
      obj.vtr = isNaN(obj.vtr) ? 0 : obj.vtr
      res.push(obj)
    })
    return res
  },

  getInterPlayDaysData: (state) => {
    let temp = state.contractData.contractAndDate
    return (adNm) => {
      if (adNm === 'total') {
        let res = []
        let tempByYmd = _.groupBy(temp, 'ymd')
        Object.keys(tempByYmd).forEach((key) => {
          let obj = {
            ymd: tempByYmd[key][0].ymd,
            imp_cnt: _.sumBy(tempByYmd[key], function (o) { return o.imp_cnt * 1 }),
            budget_amt: _.sumBy(tempByYmd[key], function (o) { return o.budget_amt * 1 }),
            click_cnt: _.sumBy(tempByYmd[key], function (o) { return o.click_cnt * 1 }),
            ctr: 0,
            view_cnt: _.sumBy(tempByYmd[key], function (o) { return o.view_cnt * 1 }),
            cpcv: _.sumBy(tempByYmd[key], function (o) { return o.cpcv * 1 }),
            cpvc: _.sumBy(tempByYmd[key], function (o) { return o.cpvc * 1 }),
            vtr: 0,
            uv_cnt: '',
            play_sec_avg: '',
            end_rate: '',
            play_Q1_rate: '',
            play_Q2_rate: '',
            play_Q3_rate: '',
            data: tempByYmd[key]
          }

          if (obj.imp_cnt !== 0 && obj.click_cnt !== 0) {
            obj.ctr = obj.click_cnt / obj.imp_cnt * 100
          }
          obj.ctr = isNaN(obj.ctr) ? 0 : obj.ctr
          if (!obj.cpcv && obj.imp_cnt !== 0 && obj.view_cnt !== 0) {
            obj.vtr = obj.view_cnt / obj.imp_cnt * 100
          }
          if (obj.cpcv) obj.vtr = 100
          obj.vtr = isNaN(obj.vtr) ? 0 : obj.vtr
          res.push(obj)
        })
        return res
      } else {
        let list = _.groupBy(temp, 'ad_knd_nm')
        return list[adNm]
      }
    }
  }
}

const actions = {
  getCampaignDetail: ({ commit }, cd) => {
    // params -> &uid=[사용자ID]&qry=[캠페인코드]
    let uid = getInfo().uid
    let url = api.getCampainDetail + '&uid=' + uid + '&qry=' + cd
    axios.get(url).then((response) => {
      commit(types.SET_CAMPAIGN_INFO, {campaign: response.data.info})
      commit(types.SET_CONTRACT_DATA, {campaign: response.data.ad})
      commit(types.SET_SIZE_DATA, {campaign: response.data.size})
      commit(types.SET_CREATIVE_DATA, {campaign: response.data.creative})
      if (response.data.group.summary.length !== 0) {
        commit(types.SET_CREATIVE_GROUP_DATA, {campaign: response.data.group})
      }
      if (response.data.geo.summary.length !== 0) {
        commit(types.SET_GEO_DATA, {campaign: response.data.geo})
      }
    }, (err) => {
      console.error(err)
    })
  }
}

const mutations = {
  // change current page
  setCurrentCampaign (state, campaign) { // --> use --> campaign main, result
    state.currentCampaign = campaign
  },
  setCurrentAdKnd (state, adKnd) {
    state.currentAdKnd = adKnd
  },
  setCampaignDetailTap (state, type) { // --> use --> resultList
    state.campaignDetailTap = type
  },
  [types.SET_CAMPAIGN_INFO] (state, {campaign}) { // --> use --> campaign main
    state.campaignInfo = campaign
  },
  [types.SET_CONTRACT_DATA] (state, {campaign}) {
    state.contractData.contract = campaign.summary
    state.contractData.contractAndDate = _.orderBy(campaign.detail, 'ymd', 'asc')
  },
  [types.SET_SIZE_DATA] (state, {campaign}) {
    let res = _.orderBy(campaign.detail, 'ymd', 'asc')
    state.currentAdKnd = res.length !== 0 ? res[0].ad_knd_nm : ''
    state.sizeData.size = campaign.summary
    state.sizeData.sizeAndDate = _.orderBy(campaign.detail, 'ymd', 'asc')
  },
  [types.SET_CREATIVE_DATA] (state, {campaign}) {
    state.creativeData.creative = campaign.summary
    state.creativeData.creativeAndDate = _.orderBy(campaign.detail, 'ymd', 'asc')
  },
  [types.SET_CREATIVE_GROUP_DATA] (state, {campaign}) {
    state.cgData.creativeGroup = campaign.summary
    state.cgData.creativeGroupAndDate = _.orderBy(campaign.detail, 'ymd', 'asc')
  },
  [types.SET_GEO_DATA] (state, {campaign}) {
    state.isGeo = campaign.summary.length !== 0
    state.geoData.geo = campaign.summary
    state.geoData.geoAndDate = _.orderBy(campaign.detail, 'ymd', 'asc')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/campaign.js